import React from 'react'

import { VimeoPlayer } from './Vimeo'
import { YouTubePlayer } from './YouTube'

export const Video: React.FC<{
  platform?: 'vimeo' | 'youtube'
  id?: string
}> = props => {
  const { platform = 'vimeo', id } = props

  return (
    <div
      className={`relative h-0 w-full bg-telesoft overflow-hidden mb-4`}
      style={{
        paddingTop: '56.25%',
      }}
    >
      {platform === 'youtube' && <YouTubePlayer videoID={id} />}
      {platform === 'vimeo' && <VimeoPlayer videoID={id} />}
    </div>
  )
}
